import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import HeaderTopic from '../../partials/HeaderTopic';

import styles from './NewPass.module.css';
import { useGetAppLinks } from '../../hooks/useGetAppLinks';
import { setNewPassword } from '../../api/setNewPassword';

function NewPass() {
  const [cell, setCell] = React.useState("");
  const [newPass1, setNewPass1] = React.useState("");
  const [newPass2, setNewPass2] = React.useState("");
  const [errorMsg, setErrorMsg] = React.useState("");

  const {signIn} = useGetAppLinks()

  const history = useHistory();

  const search = useLocation().search;
  const token = new URLSearchParams(search).get("token");

  // valid the password >>> send to server >>> handle response
  const handleSubmit = async () => {
    if (cell.length !== 10) {
      setErrorMsg("מספר טלפון אינו תקין");
    } else if (cell[0] !== "0") {
      setErrorMsg("מספר טלפון לא תקין");
    } else if (newPass1 !== newPass2) {
      setErrorMsg("הססמאות אינן תואמות");
    } else if (newPass1.length < 5) {
      setErrorMsg("סיסמה קצרה - לפחות 5 תווים");
    } else {
      setErrorMsg("יש להמתין לחידוש הסיסמה");
      const res = await setNewPassword(cell, newPass1, token);
      if (!res.error) {
        setErrorMsg("התקבל - ניתן להיכנס עם הסיסמה החדשה");
        setTimeout(() => {
          history.push(signIn);
        }, 1800);
      } else {
        setErrorMsg("משהו השתבש - יש לנסות שוב עוד כמה דקות");
      }
    }
  };

  return (
    <div className={styles.newPass}>
      <HeaderTopic topic="עדכון סיסמה" />

      <form>
        <input
          type="tel"
          value={cell}
          placeholder="מספר נייד"
          onChange={(e) => setCell(e.target.value)}
        />

        <input
          type="password"
          value={newPass1}
          placeholder="סיסמה חדשה"
          onChange={(e) => setNewPass1(e.target.value)}
        />

        <input
          type="password"
          value={newPass2}
          placeholder="שוב - סיסמה חדשה"
          onChange={(e) => setNewPass2(e.target.value)}
        />

        <span>{errorMsg}</span>
        <button type="button" className="btnLarge" onClick={handleSubmit}>
          יצירת סיסמה חדשה
        </button>
      </form>
    </div>
  );
}

export default NewPass;
